export const TWO_FACTOR_PASSWORD_ERRORS = {
  FORBIDDEN: 'You cannot verify another user\'s password.',
  INVALID: 'Incorrect password. Please try again.',
  LOCKOUT: 'You\'ve exceeded the maximum amount of login attempts.',
  NETWORK: 'Network error',
  REQUIRED: 'Password is required',
  UNKNOWN: 'Unable to verify your password. Please try again.',
};

export const TWO_FACTOR_PASSWORD_MAX_ATTEMPTS = 5;

export const TWO_FACTOR_PASSWORD_LOCKOUT_DEFAULT_SEC = 300;

export const TWO_FACTOR_INITIATE_ERRORS = {
  GENERIC: 'Unable to send the verification code. Please try again.',
  MAX_RETRIES: 'Too many attempts.',
  NO_EMAIL: 'No email on file. Update your profile first.',
  NO_PHONE: 'No phone number on file. Update your profile first.',
  NOTIFICATION_FAILED: 'Failed to send the OTP notification.',
  SERVICE_UNAVAILABLE: 'OTP service is not available.',
  UNKNOWN: 'Unable to send the verification code. Please try again.',
};

export const TWO_FACTOR_VERIFY_ERRORS = {
  EXPIRED: 'This code has expired. Request a new one.',
  GENERIC_ASYNC: 'Something went wrong. Please try again.',
  INVALID: 'The code you entered is incorrect. Please try again.',
  LOCKOUT: 'Too many verify OTP code attempts. Please try again later.',
};

export const TWO_FACTOR_VERIFY_RESEND_GUIDANCE =
  'You can click Resend to retry the new OTP code. Because you reached the max verify attempts, the Resend wait time increases to 5 minutes.';

export const TWO_FACTOR_VERIFY_MAX_ATTEMPTS = 5;

export const RESEND_COOLDOWN_NORMAL_SEC = 60;

export const RESEND_COOLDOWN_AFTER_FIVE_ATTEMPTS_SEC = 300;

export const TWO_FACTOR_VERIFY_LOCKOUT_DEFAULT_SEC = 300;

export const TWO_FACTOR_RESEND_SUCCESS = 'A new code was sent';

export const TWO_FACTOR_RESEND_MAX_ATTEMPTS = 5;

export const TWO_FACTOR_SESSION_RESTART_SUFFIX =
  'Please restart the setup process.';

export const TWO_FACTOR_RESEND_ERRORS = {
  GENERIC_ASYNC: 'Something went wrong. Please try again.',
  MAX_RETRIES: 'Maximum resend attempts reached. Please try again later.',
  SESSION_EXPIRED: 'Session expired.',
  SESSION_NOT_FOUND: 'Session not found.',
};

export const TWO_FACTOR_FLOW = {
  DISABLE: 'disable',
  ENABLE: 'enable',
};

export const TWO_FACTOR_LOCKOUT_SOURCE = {
  PASSWORD: 'password',
  VERIFY: 'verify',
};

export const TWO_FACTOR_DISABLE_ERRORS = {
  UNAUTHORIZED: 'Your session has expired. Please sign in again.',
  FORBIDDEN: 'You cannot disable two-factor authentication for this account.',
  GENERIC: 'Unable to disable two-factor authentication. Please try again.',
};



// WEBPACK FOOTER //
// ./src/constants/twoFactorMessages.js